import stylex from '@stylexjs/stylex';
import { styles } from './styles';

import { Checkbox } from '@shared/ui/kit';
import { FC } from 'react';
import { IconButton } from '@shared/ui/icon-button';
import { TrashIcon, PlusIcon } from '@shared/assets/icons';
import { colors } from '@shared/tokens/colors.stylex';

interface ISegmentProps {
  checked?: boolean;
  isIndeterminate?: boolean;
  title: string;
  onDelete?: () => void;
  onAddParticipants?: () => void;
  onChange: (checked: boolean) => void;
  quantity?: number;
  showDeleteButton?: boolean;
  showAddButton?: boolean;
}

export const Segment: FC<ISegmentProps> = ({
  title,
  onDelete,
  onAddParticipants,
  checked,
  isIndeterminate,
  onChange,
  quantity,
  showDeleteButton = true,
  showAddButton = true,
}) => {
  const truncatedTitle = title.length > 40 ? title.slice(0, 40) + '...' : title;

  return (
    <div {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.body)}>
        <Checkbox isIndeterminate={isIndeterminate} isChecked={checked} onChange={() => onChange(!checked)} />
        <p {...stylex.props(styles.title)}>{truncatedTitle}</p>
        <p {...stylex.props(styles.quantity)}>участников: {quantity}</p>
      </div>
      <div {...stylex.props(styles.actions)}>
        {showDeleteButton && (
          <div {...stylex.props(styles.iconContainer)}>
            <IconButton icon={<TrashIcon color={colors.tertiaryIcon} />} onClick={onDelete} />
          </div>
        )}
        {showAddButton && (
          <div {...stylex.props(styles.iconContainer)}>
            <IconButton icon={<PlusIcon color={colors.tertiaryIcon} />} onClick={onAddParticipants} />
          </div>
        )}
      </div>
    </div>
  );
};
